<h2 class="first_title">Notifiche</h2>
<div export-help [pageNumber]="'159'"></div>
<div class="content-page-wrapper">
	<div class="standardpanel">
		<ng-template [ngIf]="notificheResponse">
		<ul notifiche-list *ngIf="notifiche.length > 0" class="notifiche" [notifiche]="notifiche" [slice]="numToViewNotifiche" [hasOptions]="true" (onReturn)="notificaEliminata()"></ul> 
		<div *ngIf="notifiche.length == 0">
			<p class="allinea_centro">Non ci sono notifiche</p>
		</div>
		</ng-template>
	</div>
       
	<div *ngIf="notificheResponse"  class="standardpanel">
		<div class="row">				
			<p *ngIf="notificheResponse.numeroNotificheTotali > notifiche.length" class="allinea_centro col-sm-12">
					<a href="javascript:void(0);" (click)="loadProssimeNotifiche()">
					<strong>Carica altri risultati</strong></a></p>					
			<p *ngIf="notificheResponse.numeroNotificheTotali <= notifiche.length" class="allinea_centro col-sm-12"><strong>Non ci sono altri risultati</strong></p>				
			<p class="allinea_centro col-sm-12"><strong>Risultati {{notifiche.length}} di {{notificheResponse.numeroNotificheTotali}}</strong></p>
		</div>
	</div>
</div>